module.exports = __webpack_public_path__ + "static/media/due-calls.0843dc3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/due-calls.svg
// module id = 875
// module chunks = 0